import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import { extractorSessionSections } from "extractorSession/extractorSessionSections";
import { useExtractorSessionDetail } from "extractorSession/useExtractorSessionDetail";
import React from "react";

interface FlightFromAiSidePanelDetailsProps {
  data: server.dto.ExtractedFlight
  artist: server.dto.ArtistSmall
}

export const FlightFromAiSidePanelDetails = (props: FlightFromAiSidePanelDetailsProps) => {
  console.log(props);
  const {
    state,
    onValueChanged,
  } = useExtractorSessionDetail(
    props.data,
    props.artist,
  );

  const sections = extractorSessionSections(state);

  return <SidePanelDetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    fields={sections}
  />
}